import { render, staticRenderFns } from "./RecetaDetallada.vue?vue&type=template&id=32c0b0dc&scoped=true&"
import script from "./RecetaDetallada.vue?vue&type=script&lang=js&"
export * from "./RecetaDetallada.vue?vue&type=script&lang=js&"
import style0 from "./RecetaDetallada.vue?vue&type=style&index=0&id=32c0b0dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0b0dc",
  null
  
)

export default component.exports